import React, { ReactElement } from 'react';
import styled from 'styled-components';
import { FormattedMessage } from 'react-intl';
import { Button } from '@empiriecom/module-components/Button';
import { Esi } from '@empiriecom/module-components/Esi';
import useConfig from '@empiriecom/module-components/hooks/useConfig';
import { FragmentConfiguration } from '@/config';
import useUrlParameters from '@/src/components/hooks/useUrlParameters';
import { useCreateRatingContext } from '../CreateRatingContext';

const TermsEsiContainer = styled.div`
  min-height: 5rem;
`;

const ButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const CreateRatingTerms = (): ReactElement => {
  const config = useConfig<FragmentConfiguration>();
  const { setCreationStep } = useCreateRatingContext();
  return (
    <>
      <TermsEsiContainer data-testid="terms-page">
        <Esi src={useUrlParameters(config.customerRatings.values.termsESI, undefined, true)} />
      </TermsEsiContainer>
      <ButtonWrapper>
        <Button
          layout="primary"
          onClick={() => setCreationStep('CREATE')}
          data-testid="terms-back-link"
        >
          <FormattedMessage id="ratings.new-rating.terms-back" defaultMessage="zurück" />
        </Button>
      </ButtonWrapper>
    </>
  );
};

export default CreateRatingTerms;
